/* eslint-disable import/prefer-default-export */

declare global {
  interface Window {
    env: Partial<NodeJS.ProcessEnv>;
  }
}

const windowEnv = typeof window !== 'undefined' ? window.env : {};

const env = {
  REACT_APP_API_BASE_URL: windowEnv.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL,
  REACT_APP_OAUTH_CLIENT_ID:
    windowEnv.REACT_APP_OAUTH_CLIENT_ID ?? process.env.REACT_APP_OAUTH_CLIENT_ID,
  REACT_APP_OAUTH_CLIENT_SECRET:
    windowEnv.REACT_APP_OAUTH_CLIENT_SECRET ?? process.env.REACT_APP_OAUTH_CLIENT_SECRET,
  REACT_APP_OAUTH_SERVER_URL:
    windowEnv.REACT_APP_OAUTH_SERVER_URL ?? process.env.REACT_APP_OAUTH_SERVER_URL,
  REACT_APP_PUBLIC_URL: windowEnv.REACT_APP_PUBLIC_URL ?? process.env.REACT_APP_PUBLIC_URL,
  REACT_APP_XPLOR_ACTIVE_BASE_URL:
    windowEnv.REACT_APP_XPLOR_ACTIVE_BASE_URL ?? process.env.REACT_APP_XPLOR_ACTIVE_BASE_URL,
} as const;

export function getEnv<K extends keyof typeof env>(name: K) {
  return env[name];
}
